export interface PasswordValidation {
  hasMinLength: boolean;
  hasMixedCase: boolean;
  hasNumber: boolean;
  allMet: boolean;
}

export function validatePassword(password: string): PasswordValidation {
  const hasMinLength = password.length >= 8;
  const hasMixedCase = /[A-Z]/.test(password) && /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  return {
    hasMinLength,
    hasMixedCase,
    hasNumber,
    allMet: hasMinLength && hasMixedCase && hasNumber,
  };
}
